import { FormBoxLabel } from './FormBoxLabel';
import { FormBoxRoot } from './FormBoxRoot';
import { FormBoxRow } from './FormBoxRow';

export const FormBox = {
  Root: FormBoxRoot,
  Label: FormBoxLabel,
  Row: FormBoxRow,
};
